export default "__VITE_ASSET__u61pO5yVFn0KK6Xem8szdw__";